import { Header, Layout, PageContent } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-tokens'
import { useEffect } from 'react'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { IReportEmbedConfiguration, models } from 'powerbi-client'
import { PowerBIEmbed } from 'powerbi-client-react'

import { useISR } from './useISR'

import analytics, { AnalyticsEvent } from '../../util/analytics'
import { AuthLayout } from '../../components/AuthLayout'
import { checkTokenAndUpdate } from '../../util/powerbi'

const INTERVAL_TIME = 30000

const StyledPageContent = styled(PageContent)`
  background-color: ${toCSSValue('color-background-secondary')};
  overflow: auto;
`

const StyledPageBody = styled(PageContent.Body)`
  .isr-container {
    aspect-ratio: 4/3;
    iframe {
      border: none;
    }
  }
`

function Loading() {
  return (
    <AuthLayout>
      <StyledPageContent style={{ alignContent: 'center', textAlign: 'center' }}>
        <PageContent.Body>
          <Layout.Stack>
            <Spin indicator={<LoadingOutlined spin />} size="large" />
            <h3>Loading...</h3>
          </Layout.Stack>
        </PageContent.Body>
      </StyledPageContent>
    </AuthLayout>
  )
}

export function ISR() {
  const { isLoading, isFetching, isrData, refetch } = useISR()

  const embedConfig: IReportEmbedConfiguration = {
    type: 'report',
    tokenType: models.TokenType.Embed,
    accessToken: isrData?.embedToken,
    id: isrData?.reportId,
    settings: {
      navContentPaneEnabled: false,
      filterPaneEnabled: false,
    },
  }

  useEffect(() => {
    analytics.track(AnalyticsEvent.PageView)
  }, [])

  useEffect(() => {
    const checkAndUpdate = () => {
      checkTokenAndUpdate(isrData?.expiration, refetch)
    }

    checkAndUpdate()
    const intervalId = setInterval(checkAndUpdate, INTERVAL_TIME)

    return () => clearInterval(intervalId)
  }, [isrData?.expiration, refetch])

  if (isLoading || isFetching) {
    return <Loading />
  }

  return (
    <AuthLayout>
      <StyledPageContent>
        <Header>
          <Header.Content>
            <Header.Title>ISR</Header.Title>
          </Header.Content>
        </Header>
        <StyledPageBody>
          <PowerBIEmbed embedConfig={embedConfig} cssClassName="isr-container" />
        </StyledPageBody>
      </StyledPageContent>
    </AuthLayout>
  )
}
